import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectChecklistAvatarComponent } from '@portal-core/project-checklists/components/project-checklist-avatar/project-checklist-avatar.component';
import { ProjectChecklistColorClassModule } from '@portal-core/project-checklists/pipes/project-checklist-color-class/project-checklist-color-class.module';
import { ProjectChecklistTooltipModule } from '@portal-core/project-checklists/pipes/project-checklist-tooltip/project-checklist-tooltip.module';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';

@NgModule({
  declarations: [
    ProjectChecklistAvatarComponent
  ],
  imports: [
    CommonModule,
    InlineButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    ProjectChecklistTooltipModule,
    ProjectChecklistColorClassModule
  ],
  exports: [
    ProjectChecklistAvatarComponent
  ]
})
export class ProjectChecklistAvatarModule { }
